import ExcelJS from 'exceljs'

export default defineNuxtPlugin(() => {
  return {
    provide: {
      ExcelJS,
    },
  }
})
